export const stylesToolbar = {
  root: {
    background: 'none',
    display: 'flex',
    justifyContent: 'center',
  },
};
